import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { load } from './app.config';
import { AppModule } from './app.module';
import { registerLocales } from './i18n/i18n.module';

console.log(CMPS_APP_DEF);

if (CMPS_APP_DEF.ENV === 'stage' || CMPS_APP_DEF.ENV === 'prod') {
    enableProdMode();
}

registerLocales();

/** router guards and resolvers run without waiting for APP_INITIALIZER. so do this instead */
// eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/promise-function-async
load().then(() => {
    return platformBrowserDynamic().bootstrapModule(AppModule);
});
